module.exports = __webpack_public_path__ + "8ad71702647a784d96bf2ddc19175c2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/news3.jpg
// module id = 199
// module chunks = 0